function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Shape");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-healthcare-1262591",
  transform: "translate(0.334000, 0.548000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M349.996,93.332 C311.402,93.332 279.996,61.926 279.996,23.332 L279.996,-7.10542736e-15 L93.336,-7.10542736e-15 L93.336,23.332 C93.336,61.926 61.93,93.332 23.336,93.332 L0,93.332 L0,280.002 C0,382.392 158.99,456.492 177.12,464.642 L186.663,468.9115 L196.206,464.642 C214.335,456.5209 373.326,382.392 373.326,280.002 L373.326,93.332 L349.996,93.332 Z M256.664,256.672 L209.996,256.672 L209.996,303.34 L163.328,303.34 L163.328,256.672 L116.664,256.672 L116.664,210.004 L163.332,210.004 L163.332,163.336 L210,163.336 L210,210.004 L256.668,210.004 L256.664,256.672 Z",
  id: "Shape"
})));

var SvgHealthcare = function SvgHealthcare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "374px",
    height: "470px",
    viewBox: "0 0 374 470",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHealthcare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Healthcare.21eee802.svg";
export { ForwardRef as ReactComponent };